import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const GlobeIcon = createSvgIcon(
  <>
    <title>globe</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <line
        data-cap="butt"
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="16"
        x2="16"
        y1="1"
        y2="31"
      />{' '}
      <line
        data-cap="butt"
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="1"
        x2="31"
        y1="16"
        y2="16"
      />{' '}
      <ellipse
        cx="16"
        cy="16"
        data-color="color-2"
        fill="none"
        rx="8.571"
        ry="15"
        strokeMiterlimit="10"
      />{' '}
      <line
        data-cap="butt"
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="3.31"
        x2="28.69"
        y1="8"
        y2="8"
      />{' '}
      <line
        data-cap="butt"
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="3.31"
        x2="28.69"
        y1="24"
        y2="24"
      />{' '}
      <circle
        cx="16"
        cy="16"
        fill="none"
        r="15"
        stroke="#222222"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
